import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchHeaderData,
  fetchFlyerData,
  fetchJobData,
} from "../../redux/slicer/careersSlice";
import Preloader from "../../assets/sab.jpeg";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";

function Careers() {
  const dispatch = useDispatch();

  const {
    data: headerData,
    loading: headerLoading,
    error: headerError,
  } = useSelector((state) => state.careers.header);

  const {
    data: flyerData,
    loading: flyerLoading,
    error: flyerError,
  } = useSelector((state) => state.careers.flyer);

  const {
    data: jobData,
    loading: jobLoading,
    error: jobError,
  } = useSelector((state) => state.careers.job);

  const [selectedFlyer, setSelectedFlyer] = useState(null);

  useEffect(() => {
    dispatch(fetchHeaderData());
    dispatch(fetchFlyerData());
    dispatch(fetchJobData());
  }, [dispatch]);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  // if (headerLoading || flyerLoading || jobLoading) {
  //   return <div>Loading...</div>; // Loading state
  // }

  // if (headerError || flyerError || jobError) {
  //   return <div>Error: {headerError || flyerError || jobError}</div>; // Error state
  // }

  // Safely check if headerData[0] exists

  if (headerLoading || flyerLoading || jobLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <img
          src={Preloader}
          alt="Loading..."
          className="w-24 h-24 sm:w-32 sm:h-32"
        />
      </div>
    );
  }

  if (headerError || flyerError || jobError) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <p className="text-red-600 text-lg font-bold">
          Error: {headerError || flyerError || jobError}
        </p>
      </div>
    );
  }

  if (!headerData || headerData.length === 0) {
    return <div>No Header Data Available</div>;
  }
  const { title, subtitle, image_url } = headerData[0];

  const closeFlyerModal = () => {
    setSelectedFlyer(null); // Reset selected flyer when closing modal
  };

  return (
    <div className="w-full">
      {/* Hero Section */}
      <div className="relative max-w-full mx-auto">
        <div className="overflow-hidden w-full  h-[300px] sm:h-[400px] relative">
          <img
            src={image_url}
            alt="carousel-slide"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 flex flex-col justify-center items-center text-center text-white bg-black bg-opacity-40 px-10">
            <h2 className="text-3xl sm:text-5xl font-bold font-titillium">
              {title}
            </h2>
            <p className="text-sm sm:text-lg mt-4 sm:mt-4 font-inter">
              {subtitle}
            </p>
          </div>
        </div>
      </div>

      {/* Flyer Section */}
      <div className="px-4 sm:px-6 lg:px-28 py-6">
        <div className="py-6" id="flyer">
          <p className="text-3xl sm:text-4xl lg:text-5xl text-primary-color font-semibold font-titillium">
            Flyer Section
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {flyerData.map((flyer, index) => (
            <div
              key={index}
              className="py-4 cursor-pointer"
              onClick={() => setSelectedFlyer(flyer)} // Open modal with the flyer
            >
              <h2 className="font-bold text-left text-lg sm:text-xl font-inter">
                {flyer.title}
              </h2>
              <img
                src={flyer.image_url}
                alt={flyer.title}
                className="w-full h-[200px] sm:h-[300px] lg:h-[400px] object-cover rounded-t-lg"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Job Listings Section */}
      <div className="px-4 sm:px-6 lg:px-28 py-6">
        <div className="py-6" id="job">
          <p className="text-3xl sm:text-5xl text-primary-color  font-titillium">
            Job Listings Section
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {jobData.map((job) => (
            <div
              key={job.id}
              className="w-full h-[200px] shadow-2xl rounded p-4 flex flex-col items-center justify-center text-center"
            >
              <h2 className="text-lg sm:text-2xl font-bold font-inter">
                {job.job_title}
              </h2>

              <h2 className="text-sm sm:text-xl mt-2 font-inter">
                Platform Name -{" "}
                <a
                  href={job.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-400 underline font-inter"
                >
                  {job.platform_name}
                </a>
              </h2>
              <div className="mt-4">
                <button
                  className="bg-[#92288C] bg-opacity-10 w-[150px] sm:w-[200px] h-[40px] text-primary-color rounded font-inter"
                  onClick={() => window.open(job.url, "_blank")} // Open URL in a new tab
                >
                  Apply Now
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Flyer Modal */}
      {/* Flyer Modal */}
      {selectedFlyer && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white p-4 rounded-lg shadow-lg max-w-[90%] sm:max-w-[600px] w-full relative">
            {/* Modal Header */}
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-lg sm:text-xl font-bold text-primary-color font-inter">
                {selectedFlyer.title}
              </h2>
              {/* Close Button */}
              <button
                type="button"
                className="text-red-600 hover:text-red-800 text-2xl sm:text-4xl font-bold"
                onClick={closeFlyerModal}
              >
                &times;
              </button>
            </div>

            {/* Large Flyer View */}
            <div className="flex flex-col items-center">
              <img
                src={selectedFlyer.image_url}
                alt={selectedFlyer.title}
                className="w-full h-[300px] sm:h-[400px] object-cover rounded-lg"
              />
            </div>
          </div>
        </div>
      )}
      <div className="px-6 pt-4 pb-2 flex justify-end mb-5">
        <button
          onClick={scrollToTop}
          className="flex items-center justify-center text-white bg-primary-color rounded-full w-[40px] h-[40px] text-2xl"
        >
          <FaArrowUp />
        </button>
      </div>
    </div>
  );
}

export default Careers;
